<!-- 江苏兴业数币抽奖活动 内嵌小程序打开 -->
<template>
  <div
    :class="{
      'jiangsu-digital-coin-lottery-index-page': true,
      'fixed-screen-height': fixedScreenHeight,
    }"
  >
    <div class="rule-btn-box">
      <span @click="toRule">活动规则</span>
      <span @click="toPrizes">我的奖品</span>
    </div>
    <div class="seat"></div>
    <div class="lucky-content" v-show="prizes.length">
      <LuckyWheel
        ref="myLucky"
        width="7.03rem"
        height="7.03rem"
        :prizes="prizes"
        :blocks="blocks"
        :buttons="buttons"
        @start="startCallback"
        @end="endCallback"
        :default-config="defaultConfig"
      />
      <div class="click-btn" @click="startCallback"></div>
    </div>
    <div class="btn-box">
      <img
        class="btn"
        :src="require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/btn2.png`)"
        alt=""
        @click="toSite"
      />
      <img
        class="btn"
        :src="require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/btn1.png`)"
        alt=""
        @click="toStep"
      />
    </div>

    <!-- 中将弹窗 -->
    <WinningPopup ref="winningPopupRef" :prize="winningData" />
    <!-- 规则弹窗 -->
    <RulePopup ref="rulePopupRef" @ruleClose="ruleClose" />
    <!-- 奖品记录弹窗 -->
    <PrizesPopup ref="prizesPopupRef" @prizesClose="startTurn" />
    <!-- 已参与弹窗 -->
    <JoinPopup ref="joinPopupRef" />
    <!-- 滑块校验 -->
    <SliderVerify
      ref="sliderVerifyRef"
      @onSuccess="() => onSuccess('noVerifyShow')"
    />
    <AntiBrushVerify
      ref="antiBrushVerifyRef"
      @onSuccess="() => onSuccess('noVerifyShow')"
    />
  </div>
</template>
<script>
import { login, getUserInfo, lottery } from '@/api/cibDCEPLottery.js'
// import { loginFun, preFetchImg } from './components/community'
import WinningPopup from './components/WinningPopup.vue'
import RulePopup from './components/RulePopup.vue'
import PrizesPopup from './components/PrizesPopup.vue'
import JoinPopup from './components/JoinPopup.vue'
import SliderVerify from '@/components/sliderVerify.vue'
import AntiBrushVerify from '@/components/AntiBrushVerify.vue'
import { encryption } from '@/utils/common'

// import moment from 'moment'
import { Toast } from 'vant'
import moment from 'moment'
// import { nextTick } from 'vue'
export default {
  components: {
    WinningPopup,
    RulePopup,
    PrizesPopup,
    JoinPopup,
    SliderVerify,
    AntiBrushVerify,
  },
  data() {
    return {
      title: '兴业银行',
      winningData: {
        couponAmount: 0,
        status: 0, // 0失败 1成功
      },
      defaultConfig: {
        speed: 5,
      },
      blocks: [],
      prizesData: [
        { text: '0.88' },
        { text: '188' },
        { text: '8.88' },
        { text: '18.88' },
        { text: '0.88' },
        { text: '188' },
        { text: '8.88' },
        { text: '18.88' },
      ],
      prizes: [
      ],
      buttons: [
        {
          radius: '40%',
          pointer: true,
          imgs: [
            {
              src: require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/btn3.png`),
              top: '-65px',
              width: '90px',
              height: '110px',
            }
          ],
        }
      ],
      lotteryDisable: false, // 抽奖中
      meetWith: 1, // 抽奖中
      loginErrorMsg: '', // 登录失败提示
      userInfo: {
        payStatus: 0,  // 支付状态 0未支付 1已支付
        lotteryStatus: 0, // 抽奖状态 0未抽奖 1已抽奖
        surplusCount: 0, // 微站商品库存
      },
      fixedScreenHeight: false,
      clickNum: 1,
    }
  },
  async created() {
    setTimeout(() => {
      this.initPrizes()
    }, 500)
    if (sessionStorage.getItem('jiangsuDigitalCoinLotteryToken')) {
      this.getUserInfo()
    } else {
      this.login()
    }

    this.startTurn()
  },
  methods: {
    onSuccess() {
      console.log('验证成功');
      this.startCallback('noVerifyShow')
    },
    login() {
      login({
        code: sessionStorage.getItem('ydsh-ph-h5-bankv3-wxcode')
      }).then(res => {
        if (res.code === 0) {
          sessionStorage.setItem('jiangsuDigitalCoinLotteryToken', res.data.token)
          this.getUserInfo()
        } else {
          Toast(res.message)
        }
      })
    },
    getUserInfo() {
      getUserInfo({}).then(res => {
        if (res.code === 0) {
          this.userInfo = res.data
        }
      })
    },
    //随机六位数
    getMathRand() {
      var Num = "";
      for (var i = 0; i < 6; i++) {
        Num += Math.floor(Math.random() * 10);
      }
      return Num
    },
    // 点击抽奖按钮会触发star回调
    startCallback(value) {
      if (this.lotteryDisable === true) {
        console.log('请不要频繁点击');
        // Toast('请不要频繁点击')
        return
      }
      if (value !== "noVerifyShow") {
        console.log('打开校验弹窗');
        this.$refs.antiBrushVerifyRef.verifyShow = true
        setTimeout(() => {
          this.$refs.antiBrushVerifyRef.onReset()
        }, 0)
        return
      }
      this.clickNum++
      this.lotteryDisable = true
      let str = 'yidain' + moment().format('YYYYMMDDHHmmss') + this.getMathRand()
      // console.log(str);
      let encryptionStr = encryption(str)
      lottery({ voucher: encryptionStr }).then(res => {
        // let res = { "code": 0, "data": { "description": "测试", "prizeId": 500, "prizeName": "8.88元立减金", "status": 1 }, "message": "操作成功" }
        this.stopTurn()
        this.$refs.myLucky.play()
        let { prizeName, status } = res.data
        this.winningData.status = status //status 0失败 1成功
        if (status === 1) {
          let str = prizeName.replace(/[^\d.]/g, "")
          let index = this.prizesData.findIndex(i => {
            return i.text === str
          })
          setTimeout(() => {
            this.$refs.myLucky.stop(index)
            this.winningData.couponAmount = str
          }, 3000)
        } else { // 发券失败
          this.$refs.myLucky.stop(-1)
          this.$refs.winningPopupRef.show = true
          this.lotteryDisable = false
        }

      }).catch((res) => {
        // const index = -1
        // this.$refs.myLucky.stop(index)
        // this.startTurn()

        setTimeout(() => {
          this.lotteryDisable = false
        }, 2000)
      })
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      if (prize.background) {
        this.$refs.winningPopupRef.show = true
        this.lotteryDisable = false
      }
    },
    // 转盘默认缓慢旋转
    startTurn(speed = 0.2) {
      this.defaultConfig.speed = speed
      setTimeout(() => {
        this.$refs.myLucky.init()
        this.$refs.myLucky.play()
      }, 1000)

    },
    // 转盘停止，旋转速度正常
    stopTurn() {
      this.defaultConfig.speed = 20
      this.$refs.myLucky.stop(-1)
    },
    // 去微站充值
    toSite() {
      if (this.userInfo.payStatus === 1) {
        this.$refs.joinPopupRef.msg = '您已参与本次活动，无法再次参与~'
        this.$refs.joinPopupRef.show = true
        return
      }
      if (this.userInfo.surplusCount === 0) {
        this.$refs.joinPopupRef.msg = '本月名额已抢完~'
        this.$refs.joinPopupRef.show = true
        return
      }

      let url = `${process.env.VUE_APP_H5_PREFIX_URL}ydsh-scenario-h5?siteNo=${process.env.VUE_APP_JIANGSU_DIGITAL_COIN_SITENO}`
      console.log(url);
      window.location.href = url
    },
    // 去图例页面
    toStep() {
      this.$router.push({ name: 'jiangsuDigitalCoinLotteryStep' })
    },
    toRule() {
      this.$refs.rulePopupRef.show = true
      this.fixedScreenHeight = true
    },
    toPrizes() {
      this.$refs.prizesPopupRef.setShow(true)
    },
    ruleClose() {
      this.fixedScreenHeight = false
    },
    // 设置奖品样式
    initPrizes() {
      this.prizes = this.prizesData.map((item, index) => {
        let obj = {
          background: index % 2 === 0 ? '#f4e0b0' : '#ffffff',
          fonts: [
            {
              text: '数币红包',
              top: '10px',
              fontSize: '12px',
              fontColor: '#111113',
              fontWeight: '600',
            },
          ],
          imgs: [
            {
              src: require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/${item.text}.png`),
              top: '35px',
              width: '43px',
              height: '22px',
            }
          ],
        }
        return obj
      })
    },

  },
}
</script>
<style lang="less" scoped>
.fixed-screen-height {
  // min-height: 600px;
  // height: 100vh;
  // overflow: hidden;
}
.jiangsu-digital-coin-lottery-index-page {
  background: url("../../../assets/imgs/jiangsuXingyeDigitalCoinLottery/bg1.jpg")
    no-repeat #3f92e3;
  background-size: 100% auto;
  width: 100%;
  overflow-x: hidden;
  // overflow: auto;
  .rule-btn-box {
    font-size: 12px;
    color: #111113;
    position: fixed;
    right: -2px;
    top: 80px;
    span {
      display: block;
      margin-bottom: 8px;
      padding: 12px 5px;
      width: 27px;
      box-sizing: border-box;
      background: #ff6f62;
      border-radius: 10px 0px 0px 10px;
      border: 2px solid #111113;
    }
  }
  .seat {
    width: 100%;
    height: 220px;
  }
  .lucky-content {
    width: 380px;
    height: 360px;
    padding: 33px 0 0 59px;
    box-sizing: border-box;
    background: url("../../../assets/imgs/jiangsuXingyeDigitalCoinLottery/bg2.png")
      no-repeat;
    background-size: 100% auto;
    position: relative;
    .click-btn {
      position: absolute;
      top: 33%;
      left: 40%;
      z-index: 10px;
      width: 80px;
      height: 80px;
      // background: #ff6f62;
    }
  }
  .btn-box {
    text-align: center;
    .btn {
      margin: 0 auto 10px auto;
      width: 70%;
    }
  }
}
</style>
